import { useMemo } from 'react'

import { Typography } from '@mui/material'
import { ImageBlob } from '@nativewaves/nw-cloud-sdk/content'
import { ColumnDef } from '@tanstack/react-table'
import { format } from 'date-fns'
import { useTranslation } from 'react-i18next'

import { CopyId } from '@shared/components/Table/Fields'
import { DATE_TIME_FORMAT } from '@shared/utils/support'

export const useColumns = () => {
  const { t } = useTranslation(['common', 'entity', 'domain'])

  return useMemo<ColumnDef<ImageBlob>[]>(
    () => [
      {
        accessorFn: (row) => (row.storeId?.length ? row.storeId : t('noNameSet')),
        id: '_name',
        header: t('name'),
        meta: {
          sizing: {
            px: 2,
            minWidth: 300,
          },
        },
        cell: ({ getValue }) => (
          <Typography variant="inherit" noWrap>
            {getValue<string>()}
          </Typography>
        ),
      },
      {
        accessorKey: 'creationTime',
        header: t('domain:Workspace.Image.creationTime'),
        meta: {
          sizing: {
            minWidth: 300,
            px: 1,
          },
        },
        cell: ({ getValue }) => (
          <Typography variant="inherit" noWrap>
            {format(new Date(getValue<string>()), DATE_TIME_FORMAT)}
          </Typography>
        ),
      },
      {
        accessorKey: 'id',
        header: t('id'),
        meta: {
          sizing: {
            width: 200,
            px: 2,
          },
        },
        cell: ({ getValue }) => <CopyId id={getValue<string>()} />,
      },
    ],
    [t],
  )
}
